import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  period: {
    current: {
      startDate: null,
      endDate: null,
    },
    upcoming: {
      startDate: null,
      endDate: null,
    },
    proration: {
      startDate: 0,
    },
  },

  total: null,
  totalUpcoming: null,
  amountDue: null,
  isAmountDueLoading: null,
  credit: {
    available: null,
    remaining: null,
  },
  status: {
    stripeProducts: 'loading',
  },
};

const slice = createSlice({
  name: 'modify',
  initialState,
  reducers: {
    loadPreview(state, action) {
      const data = action.payload.body.data;
      state.period.current.startDate = data.currentPeriodStartDate;
      state.period.current.endDate = data.currentPeriodEndDate;

      state.period.upcoming.startDate = data.upcomingPeriodStartDate;
      state.period.upcoming.endDate = data.upcomingPeriodEndDate;

      state.period.proration.startDate = data.prorationStartDate;

      state.total = data.subtotal;
      state.amountDue = data.totalDueNow;
      state.isAmountDueLoading = false;
      state.totalUpcoming = data.totalUpcoming;

      state.credit.available = data.availableCredit;
      state.credit.remaining = data.remainingCredit;

      state.tax = data.tax;
      state.proratedTax = data.proratedTax;
      state.subtotalProrated = data.subtotalProrated;
    },
    updateStripeProductsStatus(state, action) {
      state.status.stripeProducts = action.payload;
    },
    isAmountDueLoading(state, action) {
      state.isAmountDueLoading = action.payload;
    }
  },
});

const modifySlice = {
  initialState,
  reducers: { [slice.name]: slice.reducer },
  actions: slice.actions,
  select: {
    period: {
      current: {
        startDate: (state) => state[slice.name].period.current.startDate,
        endDate: (state) => state[slice.name].period.current.endDate,
      },
      upcoming: {
        startDate: (state) => state[slice.name].period.upcoming.startDate,
        endDate: (state) => state[slice.name].period.upcoming.endDate,
      },
      proration: {
        startDate: (state) => state[slice.name].period.proration.startDate,
      },
    },

    totalUpcoming: (state) => state[slice.name].totalUpcoming,
    total: (state) => state[slice.name].total,
    amountDue: (state) => state[slice.name].amountDue,
    isAmountDueLoading: (state) => state[slice.name].isAmountDueLoading,
    tax: (state) => state[slice.name].tax,
    proratedTax: (state) => state[slice.name].proratedTax,
    subtotalProrated: (state) => state[slice.name].subtotalProrated,

    credit: {
      available: (state) => state[slice.name].credit.available,
      remaining: (state) => state[slice.name].credit.remaining,
    },

    status: {
      stripeProducts: (state) => state[slice.name].status.stripeProducts,
    },
  },
  rememberedKeys: [],
};

export default modifySlice;
